import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card } from '@totalsoft/rocket-ui';
import DocumentCommentsContainer from './DocumentCommentsContainer';

function DocumentComments({ documentId, siteId, history, fullScreen }) {
  const [dirtyComment, setDirtyComment] = useState(false);
  return fullScreen ? (
    <Card disablePadding>
      <DocumentCommentsContainer
        documentId={documentId}
        siteId={siteId}
        history={history}
        fullScreen={fullScreen}
        dirtyComment={dirtyComment}
        setDirtyComment={setDirtyComment}
      />
    </Card>
  ) : (
    <DocumentCommentsContainer
      documentId={documentId}
      siteId={siteId}
      history={history}
      fullScreen={fullScreen}
      dirtyComment={dirtyComment}
      setDirtyComment={setDirtyComment}
    />
  );
}

DocumentComments.propTypes = {
  documentId: PropTypes.number,
  siteId: PropTypes.number,
  history: PropTypes.object.isRequired,
  fullScreen: PropTypes.bool.isRequired
};

export default DocumentComments;
